import React from "react";
import useApi from "Hooks/useApi";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
  IconButton,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  DateTimePicker,
} from "@material-ui/pickers";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import ClearIcon from "@material-ui/icons/Clear";
import SpeakerNotesOff from "@material-ui/icons/VoiceOverOff";
import FilterList from "@material-ui/icons/FilterList";
import DateFnsUtils from "@date-io/date-fns";
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";

import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import format from "date-fns/format";
import jaLocale from "date-fns/locale/ja";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(3),
    "& input[type=text]": {
      color: "#000",
    },
    "& span:last-child": {
      color: "#000",
    },

  },
  black: {
    color: "#000",
    "& input[type=text]": {
      color: "#000",
    },
  },
  selectWrapper: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    "& span:last-child": {
      color: "#000",
    },
  },
  wrapperComment: {
    marginTop: theme.spacing(1),
  },
  dateWrapper: {
    display: "flex",
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  clearButton: {
    width: "32px",
    height: "32px",
  },
  selectFormControl: {
    width: "125px"
  },
  dtmSelectControl: {
    width: "400px"
  },
  comment: {
    marginLeft: "10px",
    fontSize: "0.8rem",
    color: "#999"
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
  label: {
    '&.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
}));

export default function Form({ data = null, noises = null, labels = null, labelMax = null, isMode = "ditail", dailyFlag = null, adminFlag = null, submit }) {
  const classes = useStyles();
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  const [name, setName] = React.useState("");
  const [desc, setDesc] = React.useState("");
  const [maxLabel, setMaxLabels] = React.useState([]);

  const [rangeFrom, setRangeFrom] = React.useState(dayjs().format("YYYY-MM-DD 00:00:00"));
  const [rangeUntil, setRangeUntil] = React.useState(null);
  const [dailyIterate, setDailyIterate] = React.useState(false);
  const [sendNotify, setSendNotify] = React.useState(true);

  const [dictNoises, setDictNoises] = React.useState({
    text: null,
    user_name: null,
    screen_name: null,
    user_desc: null,
  });
  const [dictLabels, setDictLabels] = React.useState([]);

  const setNoisText = (event) => {
    setDictNoises({ ...dictNoises, text: event.target.value });
  };
  const setNoisUser = (event) => {
    setDictNoises({ ...dictNoises, user_name: event.target.value });
  };
  const setNoisScreen = (event) => {
    setDictNoises({ ...dictNoises, screen_name: event.target.value });
  };
  const setNoisDesc = (event) => {
    setDictNoises({ ...dictNoises, user_desc: event.target.value });
  };
  const setDailyIterateBtn = (event) => {
    setDailyIterate(event.target.checked);
  };
  const setSendNotifyBtn = (event) => {
    setSendNotify(event.target.checked);
  };

  const [minFromDate, setFromMinDate] = React.useState(dayjs().subtract(3, "month"));
  const [maxFromDate, setFromMaxDate] = React.useState(dayjs().add(12, 'M'));
  const [minUntilDate, setUntilMinDate] = React.useState(dayjs());
  const [maxUntilDate, setUntilMaxDate] = React.useState(dayjs(dayjs().subtract(1, "day")).add(3, "month"));

  // カレンダーの表示フォーマット
  class ExtendedUtilsFrom extends DateFnsUtils {
    getDateTimePickerHeaderText(date) {
      return format(date, "MM/dd", { locale: this.locale });
    }
    getMinuteText(date){
      return format(date, "00", { locale: this.locale });
    }
  }
  class ExtendedUtilsUntil extends DateFnsUtils {
    getDateTimePickerHeaderText(date) {
      return format(date, "MM/dd", { locale: this.locale });
    }
    getMinuteText(date){
      return format(date, "59", { locale: this.locale });
    }
  }

  React.useEffect(() => {
    // 分類辞書登録上限数取得
    setMaxLabels(labelMax);
  }, [labelMax]);

  React.useEffect(() => {
    // 新規作成で毎日予約の新規登録ボタンから遷移した場合は自動チェック
    if (isMode === "create" && dailyFlag) {
      setDailyIterate(true);
    } else if (isMode === "create" && !dailyFlag) {
      setDailyIterate(false);
    }
  }, [isMode, dailyFlag]);

  React.useEffect(() => {
    if (!data) return;
    if (!data.name) return;

    setName(data.name);
    setDesc(data.desc);
    setRangeFrom(data.range_from);
    setRangeUntil(data.range_until);
    setDailyIterate(data.daily_iterate);
    setSendNotify(data.send_notify);
    setDictNoises(data.dict_noises);
    setDictLabels(data.dict_labels);

    // 開始日時の最低日を更新
    setFromMinDate(dayjs(dayjs(data.range_until).add(1, "day")).subtract(3, "month"));
    // 終点日時の最低日、最大日を更新
    setUntilMinDate(dayjs(dayjs(data.range_from)));
    setUntilMaxDate(dayjs(dayjs(data.range_from).add(3, "month")).subtract(1, "day"));
  }, [data]);

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  const setLabel = (event, num) => {
    // 重複した選択肢を選んだ場合はエラー
    for (var d in dictLabels){
      if  (dictLabels[d] != null && dictLabels[d] === event.target.value) {
        alert(messages.validation.dictLabels);
        return;
      }
    }
    // すぐ上の選択が空であればエラー
    if (num > 0 && !dictLabels[num -1] ) {
      alert(messages.validation.missingSelect);
      return;
    }
    // 未選択時、すぐ下に選択があればエラー
    if (num < (maxLabel.length -1) && event.target.value == null && dictLabels[num +1] ) {
      alert(messages.validation.missingSelect);
      return;
    }
    if (event.target.value == null) {
      // 未選択時は配列から削除する
      setDictLabels((dictLabels) => dictLabels.filter((val, index) => index !== num))
    } else if (!dictLabels[num] && dictLabels.length < maxLabel.length ) {
      // 配列に値を追加する
      setDictLabels([ ...dictLabels, event.target.value ]);
    } else {
      // 配列の値を書き換える
      setDictLabels(dictLabels.map((val, index) => (index === num ? event.target.value : val)))
    }
  };

  const dateValidation = (date, type) => {
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY-MM-DD HH:mm:ss").isValid()) {
      // 現在日時の3ヵ月前の日時を取得（00時指定）
      let maxdate = dayjs().add(12, 'M').format("YYYY-MM-DD 26.59.59");
      if (type == "rangeFrom") {
        // 始点年月日時のチェック
        let dateFrom   = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        let dateUntil  = dayjs(rangeUntil).format("YYYY-MM-DD HH:mm:ss");
        let monthUntil = dayjs(rangeUntil).subtract(3, 'M').format("YYYY-MM-DD HH:mm:ss");
        let perioddate = dayjs().subtract(3, 'M').format("YYYY-MM-DD 00:00:00");
        if (dayjs(maxdate).isBefore(dayjs(dateFrom))) {
          // 始点年月日時が現在日時から1年以上後の場合はエラー
          alert(messages.validation.UntilOver);
        } else if (dayjs(perioddate).isAfter(dayjs(dateFrom))) {
          // 始点年月日時が現在日時から3ヵ月以上前の場合はエラー
          alert(messages.validation.rangeFromOver);
        } else if (dayjs(dateUntil).isValid() && (dayjs(monthUntil).isSameOrAfter(dayjs(dateFrom)))) {
          // 始点年月日時から終点年月日時の差が3ヵ月以上の場合はエラー
          alert(messages.validation.rangeOver);
        } else if (dayjs(dateUntil).isValid() && (dayjs(dateFrom).isSameOrAfter(dayjs(dateUntil)))) {
          // 始点年月日時が終点年月日時より後の場合はエラー
          alert(messages.validation.dateRang);
        } else {
          // 比較対象がnullか、エラーがなければ値を設定
          setRangeFrom(dayjs(date).format("YYYY-MM-DD HH:00:00"));
          // 終点日時の最低日、最大日を更新
          setUntilMinDate(dayjs(date));
          if (dayjs().add(12, 'M').isBefore(dayjs(dayjs(date).add(3, "month")).subtract(1, "day"))) {
            setUntilMaxDate(dayjs().add(12, 'M'));
          } else {
            setUntilMaxDate(dayjs(dayjs(date).add(3, "month")).subtract(1, "day"));
          }
        }
      } else if (type == "rangeUntil"){
        // 終点年月日時のチェック
        let dateFrom  = dayjs(rangeFrom).format("YYYY-MM-DD HH:mm:ss");
        let dateUntil = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        let monthFrom = dayjs(rangeFrom).add(3, 'M').format("YYYY-MM-DD HH:mm:ss");
        if (dayjs(maxdate).isBefore(dayjs(dateUntil))) {
          // 終点年月日時が現在日時から1年以上後の場合はエラー
          alert(messages.validation.UntilOver);
        } else if (dayjs(dateUntil).isValid() && (dayjs(monthFrom).isSameOrBefore(dayjs(dateUntil)))) {
          // 始点年月日時から終点年月日時の差が3ヵ月以上の場合はエラー
          alert(messages.validation.rangeOver);
        } else if (dayjs(dateFrom).isValid() && (dayjs(dateUntil).isBefore(dayjs(dateFrom)))) {
          // 始点年月日時が終点年月日時より後の場合はエラー
          alert(messages.validation.dateRang);
        } else {
          // 比較対象がnullか、エラーがなければ値を設定
          setRangeUntil(dayjs(date).format("YYYY-MM-DD HH:59:59"));
          // 開始日時の最低日、最大日を更新
          setFromMinDate(dayjs(dayjs(date).add(1, "day")).subtract(3, "month"));
          setFromMaxDate(dayjs(dayjs(date)));
        }
      }
      return;
    }
    return;
  }

  // 期間クリア
  function clearRange(e) {
    e.stopPropagation();
    setRangeFrom(dayjs().format("YYYY-MM-DD 00:00:00"));
    setRangeUntil(null);
    setFromMinDate(dayjs().subtract(3, "month"));
    setFromMaxDate(dayjs().add(12, 'M'));
    setUntilMinDate(dayjs());
    setUntilMaxDate(dayjs(dayjs().subtract(1, "day")).add(3, "month"));
  }

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <ValidatorForm
      onSubmit={(e) => {
        e.preventDefault();
        submit(
          { 
            name,
            desc,
            dailyIterate,
            rangeFrom,
            rangeUntil,
            sendNotify,
            dictNoises,
            dictLabels,
          }
        );
      }}
      onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isMode == "detail" ? "投稿分類タスク詳細" : isMode == "create" ? "投稿分類タスク登録" : isMode == "edit" ? "投稿分類タスク編集": "投稿分類タスク複製"}
          </Typography>
          <Grid item xs={12} className={classes.wrapper}>
            <TextValidator
              label="タスク名*"
              fullWidth
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
              validators={['required']}
              disabled={isMode == "detail"}
              errorMessages={[messages.validation.required]}
            />
          </Grid>
          <Grid item xs={12} className={classes.wrapper}>
            <TextValidator
              label="概要"
              fullWidth
              value={desc}
              onChange={(event) => {
                setDesc(event.target.value);
              }}
              disabled={isMode == "detail"}
            />
          </Grid>
          <Grid item xs={12} className={classes.wrapper}>
          <FormLabel style={{ color: "#000"}}>{(adminFlag) ? <Button startIcon={<SpeakerNotesOff />} href="/config/dictionarysetting/noise" style={{fontSize:"100%", paddingLeft:"0px"}}>ノイズ辞書</Button> : "ノイズ辞書" }</FormLabel>
          </Grid>
          <Grid item xs={12} className={classes.wrapperComment}>
            <FormLabel>ノイズ判定は、RT⇒重複⇒目的外⇒ひらがな判定の順に既定として適用されます。<br /><span className={classes.comment} style={{ color: "#999"}}>※ノイズ判定の詳細はマニュアルを参照</span></FormLabel>
          </Grid>
          <Grid item xs={12} className={classes.selectWrapper}>
            <InputLabel>ノイズ辞書(ツイート本文)<span className={classes.comment} style={{ color: "#999"}}>※登録済辞書から１つ選択</span></InputLabel>
            <Select
                value={dictNoises.text || ""}
                onChange={setNoisText}
                name="nois"
                disabled={isMode == "detail"}
                className={classes.dtmSelectControl}
                style={{ color: '#000' }}
              >
                <MenuItem value={null}>未選択</MenuItem>
                {noises.map((row) => 
                  (row.check_for == 'text') ?
                  <MenuItem value={row.id}>{row.name}</MenuItem> : ""
                )}
            </Select>
          </Grid>
          <Grid item xs={12} className={classes.selectWrapper}>
            <InputLabel>ノイズ辞書(投稿者名)<span className={classes.comment} style={{ color: "#999"}}>※登録済辞書から１つ選択</span></InputLabel>
            <Select
                value={dictNoises.user_name || ""}
                onChange={setNoisUser}
                name="nois"
                disabled={isMode == "detail"}
                className={classes.dtmSelectControl}
                style={{ color: '#000' }}
              >
                <MenuItem value={null}>未選択</MenuItem>
                {noises.map((row) => 
                (row.check_for == 'user_name') ?
                  <MenuItem value={row.id}>{row.name}</MenuItem> : ""
                )}
            </Select>
          </Grid>
          <Grid item xs={12} className={classes.selectWrapper}>
            <InputLabel>ノイズ辞書(投稿者ID)<span className={classes.comment} style={{ color: "#999"}}>※登録済辞書から１つ選択</span></InputLabel>
            <Select
                value={dictNoises.screen_name || ""}
                onChange={setNoisScreen}
                name="nois"
                disabled={isMode == "detail"}
                className={classes.dtmSelectControl}
                style={{ color: '#000' }}
              >
                <MenuItem value={null}>未選択</MenuItem>
                {noises.map((row) => 
                (row.check_for == 'screen_name') ?
                  <MenuItem value={row.id}>{row.name}</MenuItem> : ""
                )}
            </Select>
          </Grid>
          <Grid item xs={12} className={classes.selectWrapper}>
            <InputLabel>ノイズ辞書(投稿者説明文)<span className={classes.comment} style={{ color: "#999"}}>※登録済辞書から１つ選択</span></InputLabel>
            <Select
                value={dictNoises.user_desc || ""}
                onChange={setNoisDesc}
                name="nois"
                disabled={isMode == "detail"}
                className={classes.dtmSelectControl}
                style={{ color: '#000' }}
              >
                <MenuItem value={null}>未選択</MenuItem>
                {noises.map((row) => 
                (row.check_for == 'user_desc') ?
                  <MenuItem value={row.id}>{row.name}</MenuItem> : ""
                )}
            </Select>
          </Grid>

          <Grid item xs={12} className={classes.wrapper}>
            <FormLabel style={{ color: "#000"}}>{(adminFlag) ? <Button startIcon={<FilterList />} href="/config/dictionarysetting/classification" style={{fontSize:"100%", paddingLeft:"0px"}}>分類辞書</Button> : "分類辞書" }</FormLabel>
          </Grid>

          {maxLabel.map((labelNum) => 
          <Grid item xs={12} className={classes.selectWrapper}>
            <InputLabel>分類辞書{labelNum + 1}<span className={classes.comment} style={{ color: "#999"}}>※登録済辞書から１つ選択</span></InputLabel>
            <Select
               value={dictLabels[labelNum] || ""}
               onChange={(event) => { setLabel(event, labelNum) }}
               name="label"
               disabled={isMode == "detail"}
               className={classes.dtmSelectControl}
               style={{ color: '#000' }}
            >
              <MenuItem value={null}>未選択</MenuItem>
              {labels.map((row) => 
                <MenuItem value={row.id}>{row.name}</MenuItem>
              )}
            </Select>
          </Grid>
          )}

          <Grid item xs={12} className={classes.wrapper}>
            <FormLabel style={{ color: "#000"}}>収集期間設定</FormLabel>
          </Grid>
          
          {(dailyFlag || dailyIterate) ?
          <Grid item xs={12} className={classes.selectWrapper}>
              <FormControl component="fieldset">
                <FormLabel><span className={classes.black}>毎日予約</span><span className={classes.comment} style={{ color: "#999"}}>※毎日0:00～23:59のデータでcsvを作成します。設定の翌日から開始します。</span></FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    classes={{ label: classes.label, }}
                    control={
                      <Checkbox 
                        checked={dailyIterate}
                        //onChange={setDailyIterateBtn} 
                        disabled={isMode == "detail"}
                        inputProps={{ readOnly: true }}
                      />
                    }
                    label="有効"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            : ""}

            {(dailyFlag || dailyIterate) ? "" :
            <Grid item xs={12} className={classes.wrapperComment}>
              <FormLabel>期間指定は、最大3ヶ月分です。</FormLabel>
            </Grid>
            }
            {(dailyFlag || dailyIterate) ? "" :
            <Grid item xs={12} className={classes.dateWrapper}>
              <FormLabel><span className={classes.black}>期間指定　</span></FormLabel>
              <MuiPickersUtilsProvider utils={ExtendedUtilsFrom} locale={jaLocale}>
                <DateTimePicker
                  label="始点日時"
                  ampm={false}
                  inputFormat='yyyy/MM/dd HH:mm:ss'
                  format="yyyy/MM/dd HH:mm:ss"
                  views={['date', 'hours']}
                  minDate={minFromDate}
                  maxDate={maxFromDate}
                  minDateMessage={(messages.validation.minDate).replace("$1",  minFromDate.format("YYYY-MM-DD"))}
                  maxDateMessage={(messages.validation.maxDate).replace("$1",  maxFromDate.format("YYYY-MM-DD"))}
                  minutesStep={60}
                  value={rangeFrom}
                  onChange={(date) => dateValidation(date, "rangeFrom")}
                  disabled={isMode == "detail"}
                  className={classes.black}
                  okLabel="決定"
                  cancelLabel="キャンセル"
                />
              </MuiPickersUtilsProvider>
              <div className={classes.divider}>〜</div>
              <MuiPickersUtilsProvider utils={ExtendedUtilsUntil} locale={jaLocale}>
                <DateTimePicker
                  label="終点日時"
                  ampm={false}
                  inputFormat='yyyy/MM/dd HH:mm:ss'
                  format="yyyy/MM/dd HH:mm:ss"
                  views={['date', 'hours']}
                  minDate={minUntilDate}
                  maxDate={maxUntilDate}
                  minDateMessage={(messages.validation.minDate).replace("$1",  minUntilDate.format("YYYY-MM-DD"))}
                  maxDateMessage={(messages.validation.maxDate).replace("$1",  maxUntilDate.format("YYYY-MM-DD"))}
                  minutesStep={60}
                  value={rangeUntil}
                  onChange={(date) => dateValidation(date, "rangeUntil")}
                  disabled={isMode == "detail"}
                  className={classes.black}
                  okLabel="決定"
                  cancelLabel="キャンセル"
                  InputProps={{
                    endAdornment: (
                      <IconButton 
                        className={classes.clearButton} 
                        disabled={isMode == "detail"}
                        onClick={(e) => clearRange(e)}>
                          <ClearIcon />
                      </IconButton>
                    )
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            }

            <Grid item xs={12} className={classes.wrapper}>
              <FormControl component="fieldset">
                <FormLabel><span style={{ color: "#000"}}>タスク完了時メール通知設定</span><span className={classes.comment} style={{ color: "#999"}}>※作成した管理者ユーザ（メールアドレス）宛てに送信します。</span></FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    classes={{ label: classes.label, }}
                    control={
                      <Checkbox 
                        checked={sendNotify}
                        onChange={setSendNotifyBtn} 
                        disabled={isMode == "detail"}
                      />
                    }
                    label="有効"
                  />
                </FormGroup>
              </FormControl>
            </Grid>

        </Paper>

        {stateError.state.isError && (
          <div className={classes.messsageWrapper}>
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
              className={classes.toast}
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        { isMode != "detail" && (
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary">
            {isMode == "create" ? "登録" : isMode == "edit" ?  "更新" : "複製"}
          </Button>
        </Grid>
        )}
      </ValidatorForm>
    </Grid>
  );
}
